import React from 'react';
import axios from 'axios';
import dlCommon from '../../dlCommon';

const apiUrlGet = dlCommon.apiUrlGet;

const fOptValGet = (fOpt, nam) => {
    let val;
    if (fOpt.hasOwnProperty(nam)) {
        val = fOpt[nam];        
    } else {
        val = fOptValDefaultGet(nam);
    }
    return val;
}

const fileNavSet = (val) => {
    let res = '';
    return res;
}

const uploadAct = () => {
    console.log('uploadAct');    

};

const fOptValDefaultGet = (nam) => {
    // return default val for option
    let val = '';

    switch (nam) {
      case 'multi': // upload one ore more files
        val = false;        
        break;
      case 'navType': // start navigation: 'fileUp' - file dialog, 'actNav' - nav element for activating file dialog
        val = 'fileUp';        
        break;
      case 'actNavText': // if navType is 'actNav' here is text to display on element for activating file up nav
        val = 'add';        
        break;
      case 'upFoldPath': // path to destination upload folder for file
        val = '';        
        break;
      case 'upFExtCh': // check file extension
        val = false;        
        break;
      case 'upFExt': // in case upFExtCh is true, here are allowed ext
        val = [];        
        break;
      case 'upOnSel': // should it activate upload on file select
        // val = true;        
        val = false;        
        break;
      case 'updResType': // how to give info about upload: 'ob' - fRes object, 'ev' - event emmiter, 'ob_ev' - both fRes object and event emmiter
        val = 'ob';        
        break;
      case 'resizeOpt': 
      /* object with options for resize image. Options are given as parameters: 
         resizeType: type of resize: w_h - resize to width or height so maximal width or height is up to whMax. default ''
         whMax: maximum size in px for width or height. default 100
         fNew: if create new im file or resize existing. default false
         fNewNam: in case fNew is true here is base name for resized image. If file with same name already exists, unique filename is generated. default 'image_resize'
      */
        val = {};        
        break;        
      case 'imAdd': // object which contain additional images to create according to resize options given for each additional image. for each image there is property slug which is object which contain property resizeOpt. Property resizeOpt is of same format as fOpt property resizeOpt.
        val = {};        
        break;
      case 'upMaxNum': // max number of files for upload
        // val = true;        
        val = 100;        
        break;
      case 'parAdd': // additional parameters, default empty object. This value is included in result object.
        // val = true;        
        val = {};        
        break;
      default:
        break;
    }

    return val;
    
};

let FileUpload = ({ fOpt, fUpAfter, fUpAfterPar }) => {
    let upProgressInfo = '';    
    let rfFUp = React.createRef();

    // console.log('fOpt - 2');
    // console.log(fOpt);

    const fUpload = (formData) => {
        // console.log(ev.target);
        // formData.append("fOpt", fOpt);
        // console.log('fOpt');
        // console.log(fOpt);
        
        const contentType = 'multipart/form-data';
        const setResponse = (msg) => console.log(msg);
        // const API_BASE = apiUrlGet('comm', 'file-up');
        axios({
            url: apiUrlGet('comm', 'file-up'),
            method: 'POST',
            data: formData,
            headers: {
                'Content-Type': contentType,
                'fOpt': JSON.stringify(fOpt),
                'f-opt': JSON.stringify(fOpt)
            }
        }).then((response) => {
          // console.log('fUpAfterPar');
          // console.log(fUpAfterPar);
            fUpAfter(response.data, fUpAfterPar);
            // setResponse(response.data);
        }).catch((error) => {
            setResponse('error');
            setResponse(error);
        });
    };

    const fUpFormDataGet = () => {
        let formData = new FormData(); 
        const n = rfFUp.current.files.length;
        for (let i = 0; i < n; i++) {
            formData.append('f_up', rfFUp.current.files[i]);        
        }  
        return formData;
    };

    const uploadAct = () => {
        let formData = fUpFormDataGet();
        fUpload(formData);
    };

    const fileChng = () => {
        const upOnSel = fOptValGet(fOpt, 'upOnSel');
        if (upOnSel) {
            uploadAct();
            rfFUp.current.value = '';
        }
    };

    const fileNavAct = true;
    const fileNav = fileNavAct ? <input id="f_up" name="f_up" type="file" ref={rfFUp} onChange={ (ev) => fileChng(ev) } multiple={ fOptValGet(fOpt, 'multi') } /> : null;

    const actNavT = !fileNav ? <div style={{ cursor: 'pointer', color: '#630920' }} onClick={ () => fileNavSet(true) }>{ fOptValGet(fOpt, 'actNavText') }</div> : null;

    const upButton = fileNavAct && !fOptValGet(fOpt, 'upOnSel') ? <button type="button" onClick={ uploadAct }>
    Upload
    </button> : null;

    return <div>
        { fileNav }
        { actNavT }
        { upButton }
        <div>{ upProgressInfo }</div>
    </div>;

};

export default FileUpload;
